import { useCallback } from 'react';

import {
  bindJoinWorkspaceInfoToEmail,
  clearJoinWorkspaceInfo as clearStoredJoinWorkspaceInfo,
  getJoinWorkspaceInfoForEmail,
  InviteType,
  peekJoinWorkspaceInfo,
  type StoredJoinInfo,
  setJoinWorkspaceInfo as setStoredJoinWorkspaceInfo,
} from '~/utils/joinWorkspaceStorage';

export { InviteType };
export type JoinInfo = StoredJoinInfo;

export const useJoinWorkspaceInfo = () => {
  const getJoinWorkspaceInfo = useCallback(() => peekJoinWorkspaceInfo(), []);

  const getJoinWorkspaceInfoForUser = useCallback((email: string) => getJoinWorkspaceInfoForEmail(email), []);

  const setJoinWorkspaceInfo = useCallback((info: JoinInfo) => {
    setStoredJoinWorkspaceInfo(info);
  }, []);

  const bindJoinWorkspaceInfoToUser = useCallback((email: string) => {
    bindJoinWorkspaceInfoToEmail(email);
  }, []);

  const clearJoinWorkspaceInfo = useCallback(() => {
    clearStoredJoinWorkspaceInfo();
  }, []);

  return {
    getJoinWorkspaceInfo,
    getJoinWorkspaceInfoForUser,
    setJoinWorkspaceInfo,
    bindJoinWorkspaceInfoToUser,
    clearJoinWorkspaceInfo,
  };
};
